import {
  GET_VENTES,
  GET_VENTES_BY_USER,
  GET_VENTES_BY_CHARGE,
  GET_SPECIFIC_VENTE,
  CLEAR_SPECIFIC_VENTE,
  ADD_VENTE,
  DELETE_VENTE,
  UPLOAD_CONTRAT_SIGNE,
  VENTES_LOADING,
  CLEAR_VENTES,
  EDIT_VENTE_CHARGE,
  EDIT_VENTE_COMMISSIONED_TO,
  EDIT_VENTE_PROMOTEUR,
  EDIT_VENTE_BIEN_PRICE,
  EDIT_VENTE,
  EDIT_ASSOCIATION,
  EDIT_CLIENT,
  EDIT_ENCAISSEMENT
} from '../types';
import { IAction, IVente } from '../../types/interfaces';

const initialState = {
  ventes: [],
  info: {},
  loading: false
};

interface IState {
  ventes: IVente[];
  info: any;
}

export default function(state: IState = initialState, action: IAction) {
  switch (action.type) {
    case GET_VENTES:
    case GET_VENTES_BY_USER:
    case GET_VENTES_BY_CHARGE:
      return {
        ...state,
        ventes: action.payload,
        loading: false
      };
    case GET_SPECIFIC_VENTE:
      return {
        ...state,
        info: action.payload,
        loading: false
      };
    case VENTES_LOADING:
      return {
        ...state,
        loading: true
      };
    case CLEAR_VENTES:
      return {
        ...state,
        ventes: []
      };
    case CLEAR_SPECIFIC_VENTE:
      return {
        ...state,
        info: {}
      };
    // case DELETE_VENTE:
    //   return {
    //     ...state,
    //     ventes: state.ventes.filter(vente => vente.lineIndex !== action.payload)
    //   };
    case ADD_VENTE:
      return {
        ...state,
        ventes: action.payload?.vente ? [...state.ventes, action.payload.vente] : state.ventes
      };
    case EDIT_VENTE:
    case EDIT_VENTE_CHARGE:
    case EDIT_VENTE_COMMISSIONED_TO:
    case EDIT_VENTE_PROMOTEUR:
    case EDIT_ASSOCIATION:
      return {
        ...state,
        ventes: state.ventes.map(e => e.id == action.payload.id ? action.payload : e),
        info: state.info.id === action.payload.id ? action.payload : state.info
      };
    case EDIT_VENTE_BIEN_PRICE:
      return {
        ...state,
        ventes: action.payload?.vente ? state.ventes.map(e => e.id == action.payload.vente.id ? action.payload.vente : e) : state.ventes,
        info: (action.payload?.vente && state.info.id === action.payload.vente.id) ? action.payload.vente : state.info
      };
    case UPLOAD_CONTRAT_SIGNE:
      return {
        ...state,
        ventes: state.ventes.map(e => e.id == action.payload.id ? action.payload : e),
        info: state.info.id === action.payload.id ? action.payload : state.info
      };
    case EDIT_CLIENT:
      return {
        ...state,
        info: {
          ...state.info,
          contrat_clients: state.info?.contrat_clients?.map(e => e.client?.id === action.payload.id ? {...e, client: action.payload} : e),
          associations: state.info?.associations?.map(e => ({...e, contrat_clients: e.contrat_clients?.map(t => t.client?.id === action.payload.id ? {...t, client: action.payload} : t)}))
        }
      };
    case EDIT_ENCAISSEMENT:
      return {
        ...state,
        info: {
          ...state.info,
          contrat_encaissements: state.info?.contrat_encaissements?.map(e => e.encaissement?.id === action.payload.id ? {...e, encaissement: action.payload} : e),
          associations: state.info?.associations?.map(e => ({...e, contrat_encaissements: e.contrat_encaissements?.map(t => t.encaissement?.id === action.payload.id ? {...t, encaissement: action.payload} : t)}))
        }
      };
    default:
      return state;
  }
}
